import { useEffect, useState } from 'react';
import { accessControlService } from '../services/accessControlService';

let cachedMenuKeys = null;
let cachePromise = null;
let cacheTimestamp = 0;
const CACHE_MS = 60 * 1000;

async function fetchMenuKeys(force = false) {
  const now = Date.now();
  if (!force && cachedMenuKeys && now - cacheTimestamp < CACHE_MS) {
    return cachedMenuKeys;
  }
  if (!force && cachePromise) return cachePromise;

  cachePromise = accessControlService
    .getMyAccess()
    .then((res) => {
      const keys = Array.isArray(res?.data?.data?.menuKeys) ? res.data.data.menuKeys : [];
      cachedMenuKeys = keys;
      cacheTimestamp = Date.now();
      return keys;
    })
    .catch(() => {
      cachedMenuKeys = [];
      cacheTimestamp = Date.now();
      return [];
    })
    .finally(() => {
      cachePromise = null;
    });

  return cachePromise;
}

export function clearMenuAccessCache() {
  cachedMenuKeys = null;
  cacheTimestamp = 0;
  cachePromise = null;
}

/**
 * Whether the current user (after corporate ceiling ∩ role/user access) has a menu_key.
 */
export function useHasMenuKey(menuKey) {
  const [hasKey, setHasKey] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    fetchMenuKeys()
      .then((keys) => {
        if (!cancelled) setHasKey(Boolean(menuKey) && keys.includes(menuKey));
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    const onUpdated = () => {
      fetchMenuKeys(true).then((keys) => {
        if (!cancelled) setHasKey(Boolean(menuKey) && keys.includes(menuKey));
      });
    };
    window.addEventListener('menu-access-updated', onUpdated);
    window.addEventListener('user-subscription-updated', onUpdated);

    return () => {
      cancelled = true;
      window.removeEventListener('menu-access-updated', onUpdated);
      window.removeEventListener('user-subscription-updated', onUpdated);
    };
  }, [menuKey]);

  return { hasKey, loading };
}
